import React from "react"
import { FormattedMessage, injectIntl } from "react-intl"
import "./styles/processing-payment-loader.scss"

type OwnProps = {
    currencyCode: string
}


const ProcessingPaymentLoader = (props: OwnProps) => {

    const currencySymbol = 
    props.currencyCode === "USD" ? "$" : 
        new Intl.NumberFormat(undefined, { style: "currency", currency: props.currencyCode }).          
            formatToParts(0).find(part => part.type === "currency")?.value


    return <div className="payment-loader-container">
        <div className="payment-loader">
            <div className="payment-circle">
                <div className="payment-inner-circle">
                </div>
                <h1>
                    {currencySymbol}
                </h1>
            </div>
        </div>
        <div className="pt-3 payment-processing-text">
            <FormattedMessage
                id="rf.cc.processing_payment"
                defaultMessage="Processing Payment ..."
            />   
        </div>
    </div>
}
export default injectIntl(ProcessingPaymentLoader)


// WEBPACK FOOTER //
// ./src/common/credit-card/rf-components/ProcessingPaymentLoader.tsx